(() => {
  'use strict';
  const button = document.querySelector('[data-wub-back-to-top]');
  if (!button || button.dataset.wubReady === 'true') return;
  button.dataset.wubReady = 'true';
  let ticking = false;
  const sync = () => {
    button.classList.toggle('is-visible', window.scrollY > window.innerHeight);
    ticking = false;
  };
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(sync);
  }, { passive: true });
  button.addEventListener('click', () => window.scrollTo({ top: 0, left: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }));
  sync();
})();
